export default __webpack_public_path__ + "static/media/team__item-img-3.784cdb57.jpg";